const pulseBlock = "bg-dark-border rounded-sm animate-pulse motion-reduce:animate-none";

const SkeletonBlock = ({ className = "" }) => (
  <div className={`${pulseBlock} ${className}`.trim()} aria-hidden="true" />
);

export const ProgressLoadingSkeleton = () => (
  <div
    className="space-y-10"
    data-testid="progress-loading"
    aria-busy="true"
    aria-label="Loading progress data"
  >
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {Array.from({ length: 8 }).map((_, index) => (
        <div key={`summary-skeleton-${index}`} className="border border-dark-border bg-dark-surface-1 p-4 space-y-3">
          <SkeletonBlock className="h-3 w-20" />
          <SkeletonBlock className="h-7 w-24" />
        </div>
      ))}
    </div>

    {Array.from({ length: 2 }).map((_, index) => (
      <div key={`section-skeleton-${index}`} className="border border-dark-border bg-dark-surface-1 p-6 space-y-4">
        <SkeletonBlock className="h-3 w-28" />
        <SkeletonBlock className="h-6 w-56" />
        <SkeletonBlock className="h-64 w-full" />
      </div>
    ))}
  </div>
);
